import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { WhatsAppWidget } from '../WhatsAppWidget';
import { MainHeader } from '../MainHeader';
import { Map } from '../map';
import lobola from './lobola.jpg';
import wedding from './weddingmain.jpg';
import florals from './floralsMain.jpg';
import birthday from './birthdaymain.jpg';
import corporate from './corporatemain.jpg';
import './styles.css';

const galleryCategories = [
  {
    title: 'Weddings',
    text: 'Elegant ceremony and reception styling created around your story.',
    image: wedding,
    to: '/gallery/Weddings',
    className: 'gallery-category--wide',
  },
  {
    title: 'Lobola',
    text: 'Meaningful celebrations that honour tradition with thoughtful detail.',
    image: lobola,
    to: '/gallery/Lobola',
    className: '',
  },
  {
    title: 'Florals',
    text: 'Fresh, expressive floral arrangements for every kind of occasion.',
    image: florals,
    to: '/gallery/Florals',
    className: '',
  },
  {
    title: 'Birthdays',
    text: 'Personal celebrations transformed into memorable experiences.',
    image: birthday,
    to: '/gallery/Birthdays',
    className: '',
  },
  {
    title: 'Corporate Events',
    text: 'Professional event environments designed to represent your organisation well.',
    image: corporate,
    to: '/gallery/Corporate',
    className: 'gallery-category--wide',
  },
];

export const GalleryPage = () => {
  useEffect(() => {
    document.title = "Ruesevents Designs - Gallery";
  }, []);

  return (
    <div className="page-shell gallery-page">
      <MainHeader home={false} about={false} gallery={true} contact={false} />

      <section className="gallery-page-heading">
        <div className="section-shell">
          <p className="section-kicker">Our work</p>
          <h1>Moments we're proud to have brought to life.</h1>
          <p>
            Explore a selection of weddings, lobola celebrations, birthdays, corporate events and
            floral work created by Ruesevents Designs.
          </p>
        </div>
      </section>

      <section className="gallery-category-section">
        <div className="section-shell gallery-category-grid">
          {galleryCategories.map((category) => (
            <Link
              key={category.title}
              to={category.to}
              className={`gallery-category-card ${category.className}`.trim()}
            >
              <img src={category.image} alt={`${category.title} by Ruesevents Designs`} loading="lazy" />
              <span className="gallery-category-overlay" />
              <span className="gallery-category-copy">
                <small>View collection</small>
                <strong>{category.title}</strong>
                <em>{category.text}</em>
              </span>
            </Link>
          ))}
        </div>
      </section>

      <Map />
      <WhatsAppWidget />
    </div>
  );
};
